









































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
@Component({
  components: {}
})
export default class TextScroll extends Vue {
  @Prop({ default: 2000 })
  private delayTime!: number; // 文字滚动间隔时间 ms
  @Prop()
  // 滚动文字的list， eg: ['这是<span style="color:red" class="test">测试</span>文字1','这是测试文字2']
  private readonly textList!: string[];
  @Prop({ default: 20 })
  private readonly height!: number; // item的高度
  @Prop({ default: {} }) // 每一列的样式
  private itemStyle: any;
  @Prop({default: false})
  private multiple?: boolean
  private translateY: number = 0;
  private intervalTimer: any = null;
  private scrollCount = 0;
  private transitionStyle: string = "all 0ms ease 0s";
  private timeoutTimer: any = null;

  private toScroll() {
    clearInterval(this.intervalTimer);
    this.intervalTimer = setInterval(() => {
      this.scrollCount++;
      this.transitionStyle = "all 1000ms ease 0s";
      this.translateY = -this.height * this.scrollCount;
      clearTimeout(this.timeoutTimer);
      this.timeoutTimer = setTimeout(() => {
        if (this.scrollCount >= this.textList.length) {
          this.transitionStyle = "all 0ms ease 0s";
          this.translateY = 0;
          this.scrollCount = 0;
        }
      }, 1000);
    }, this.delayTime);
  }

  private init() {
    this.$nextTick(() => {
      this.toScroll();
    });
  }
  private mounted() {
    this.init();
  }
  private destroyed() {
    clearInterval(this.intervalTimer);
  }
  private activated() {
    this.init();
  }
  private deactivated() {
    clearInterval(this.intervalTimer);
  }
}
